export default [
  {
    icon: 'mdi-lock-outline',
    name: 'OpenData',
    path: '/opendata',
    component: () => import(/* webpackChunkName: "opendata" */ '@/views/RouterViewComponent'),
    redirect: '/opendata/form/wellcome',
    id: 'opendata-toolbar',

    meta: {
      requiresAuth: true,
      allowedRoles: ['lopd', 'consultant', 'admin', 'superadmin'],
      toolbar: true,
      tooltip: null,
    },
    children: [
      {
        name: 'Cuestionario LOPD-RGPD',
        icon: 'mdi-file-document-edit-outline',
        path: '/opendata/form/wellcome',
        component: () =>
          import(/* webpackChunkName: "opendata-wellcome" */ './views/OpendataWellcome'),
        meta: {
          requiresAuth: true,
          allowedRoles: ['lopd', 'consultant', 'admin', 'superadmin'],
          drawer: true,
          tooltip: null,
        },
      },
      {
        name: 'Cuestionario LOPD-RGPD',
        icon: 'mdi-file-document-edit-outline',
        path: '/opendata/form/:id/:step',
        props: true,

        component: () => import(/* webpackChunkName: "opendata-form" */ './views/OpendataForm'),
        meta: {
          requiresAuth: true,
          allowedRoles: ['lopd', 'consultant', 'admin', 'superadmin'],
          tooltip: null,
          drawer: false,
        },
      },
      {
        name: 'Cuestionario LOPD-RGPD',
        icon: 'mdi-clipboard-text-play-outline',
        path: '/opendata/checklist/:id',
        props: true,

        component: () =>
          import(/* webpackChunkName: "opendata-wellcome" */ './views/OpendataChecklist'),
        meta: {
          requiresAuth: true,
          allowedRoles: ['lopd', 'consultant', 'admin', 'superadmin'],
          drawer: false,
          tooltip: null,
        },
      },
      // {
      //   name: "Documentación",
      //   icon: "mdi-folder-text-outline",
      //   path: "/opendata/documentation",
      //   props: true,

      //   component: () =>
      //     import( /* webpackChunkName: "opendata-form" */ "./views/OpendataDocumentationAllCompanies"),
      //   meta: {
      //     requiresAuth: true,
      //     allowedRoles: ['lopd', 'consultant', 'admin', 'superadmin'],

      //     drawer: true
      //   }
      // },
      // {
      //   name: "Documentación",
      //   icon: "mdi-folder-text-outline",
      //   path: "/opendata/documentation/:id",
      //   props: true,

      //   component: () =>
      //     import( /* webpackChunkName: "opendata-form" */ "./views/OpendataDocumentationSingleCompany"),
      //   meta: {
      //     requiresAuth: true,
      //     allowedRoles: ['lopd', 'consultant', 'admin', 'superadmin'],

      //     drawer: false
      //   }
      // }
    ],
  },
];
